import React from 'react';
import {IconButton, TextField, Toolbar, Tooltip, Typography} from '@material-ui/core';
import {
    AddBox,
    AddCircleOutlineOutlined,
    Adjust,
    DeleteForeverRounded,
    PlayCircleFilledOutlined,
    StopRounded
} from '@material-ui/icons'
import DownloadAllIcon from "@material-ui/icons/CloudDownloadTwoTone";
import EmailIcon from "@material-ui/icons/ContactMail";
import {ClearAllTwoTone} from "@mui/icons-material";

export function PhishToolbar(props){
    const {
        sendTemplate,
        clearTargets,
        newRse,isAllowNewRse, newCampaign, isAllowNewCampaign,
        deleteRse, isAllowDeleteRse,
        isAllowClearTargets,
        isAllowEditCampaign, editCampaign,
        isAllowStart, startCampaign,
        isAllowStop, stopCampaign,
        isAllowDeleteCampaign, deleteCampaign,
        isAllowReport, reportCampaign,
        onClientFilter
    } = props;

    return <Toolbar style={{ backgroundColor: '#eee', boxShadow: '3px 3px #ccc', borderRadius: '3px' }}>
        <Typography variant="h6" color="primary" style={{ marginRight: '30px' }}>CastleGarde RSE</Typography>

        <Tooltip title={'Send Template'}><div><IconButton onClick={sendTemplate}
        ><EmailIcon /></IconButton></div></Tooltip>

        <TextField label='Filter Clients'
                   onChange={e => onClientFilter(e.target.value)}
                   variant='outlined' />

        {
            isAllowNewRse ?
                <Tooltip title={'New RSE'}><div><IconButton onClick={newRse} style={{backgroundColor:'lightblue'}}
                ><AddBox /></IconButton></div></Tooltip>
                : ''
        }
        {
            isAllowDeleteRse ?
                <Tooltip title={'Delete RSE'}><div><IconButton onClick={deleteRse} style={{backgroundColor:'lightblue'}}
                ><DeleteForeverRounded /></IconButton></div></Tooltip>
                : ''
        }
        {
            isAllowClearTargets?
                <Tooltip title={'Delete All Targets'}><div><IconButton onClick={clearTargets}>
                    <ClearAllTwoTone/>
                </IconButton> </div></Tooltip>:''
        }
        {
            isAllowNewCampaign ?
                <Tooltip title={'New Campaign'}><div><IconButton onClick={newCampaign} style={{backgroundColor:'lightcoral'}}
                ><AddCircleOutlineOutlined /></IconButton></div></Tooltip>
                : ''
        }
        {
            isAllowEditCampaign ?
                <Tooltip title={'Edit Campaign'}><div><IconButton onClick={editCampaign}
                ><Adjust /></IconButton></div></Tooltip>
                : ''
        }
        {
            isAllowStart ?
                <Tooltip title={'Start Campaign'}><div><IconButton onClick={startCampaign}
                ><PlayCircleFilledOutlined /></IconButton></div></Tooltip>
                : ''
        }
        {
            isAllowStop ?
                <Tooltip title={'Stop Campaign'}><div><IconButton onClick={stopCampaign}
                ><StopRounded /></IconButton></div></Tooltip>
                : ''
        }
        {
            isAllowDeleteCampaign ?
                <Tooltip title={'Delete Campaign'}><div><IconButton onClick={deleteCampaign}
                ><DeleteForeverRounded /></IconButton></div></Tooltip>
                : ''
        }
        {
            isAllowReport ?
                <Tooltip title={'Generate Report'}><div><IconButton onClick={reportCampaign}
                ><DownloadAllIcon /></IconButton></div></Tooltip>
                : ''
        }
    </Toolbar>
}